import type { CrmIntegrationType } from '@shared';
import { CaspioPhoneOverrideModal } from './caspio-phone-override-modal';
import { PlatformPhoneOverrideModal } from './platform-phone-override-modal';
import type { SystemOrganizationPhoneNumber } from './graphql';

export function PhoneCrmOverrideModal({
  phoneNumber,
  type,
  onClose,
}: {
  phoneNumber: SystemOrganizationPhoneNumber;
  type: CrmIntegrationType;
  onClose: () => void;
}) {
  if (type === 'platform') return <PlatformPhoneOverrideModal phoneNumber={phoneNumber} onClose={onClose} />;

  return <CaspioPhoneOverrideModal phoneNumber={phoneNumber} onClose={onClose} />;
}
